(() => {
  document.querySelectorAll('.navigation-bar').forEach((navigationBar) => {
    if (navigationBar.dataset.initialized) {
      return;
    }

    navigationBar.dataset.initialized = 'true';

    const targetSections = document.querySelectorAll('#MainContent > .shopify-section');

    if (targetSections.length === 0) {
      console.warn('No target sections (e.g., .shopify-section) found.');
      return;
    }

    navigationBar.querySelectorAll('a').forEach((link, linkIndex) => {
      link.addEventListener('click', (evt) => {
        evt.preventDefault();

        let targetElement = navigationBar.closest('.shopify-section');

        for (let i = 0; i <= linkIndex; i++) {
          if (targetElement && targetElement.nextElementSibling) {
            targetElement = targetElement.nextElementSibling;
          } else {
            targetElement = null;
            console.warn(
              `Could not find the ${i + 1}-th sibling element after the navigator-bar for link at index ${linkIndex}.`,
              navigationBar
            );
            break;
          }
        }

        if (targetElement) {
          const targetElementRect = targetElement.getBoundingClientRect();
          const targetElementTopAbsolute = targetElementRect.top + window.pageYOffset;
          const scrollOffset = (document.querySelector('.theme__header')?.clientHeight || 0) + (navigationBar?.clientHeight || 0);

          const scrollToPosition = targetElementTopAbsolute - scrollOffset;

          window.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  });
})();